import { ReactNode } from 'react'

import cn from '@/utilities/cn'

import './index.scss'

import { CarrotLeft } from '@/components/Icons'

type HeaderProps = {
  backNavTitle?: ReactNode
  buttons?: ReactNode
  className?: string
  children?: ReactNode
  goBack?: () => void
  title?: ReactNode
}

function Header({ backNavTitle, buttons, children, className, goBack = () => null, title }: HeaderProps) {
  return (
    <div className={cn('page-header', className)}>
      <div className="page-header__title">
        {!!backNavTitle && (
          // eslint-disable-next-line jsx-a11y/no-static-element-interactions
          <span onClick={goBack} className="page-header__back-nav">
            <CarrotLeft />
            {backNavTitle}
          </span>
        )}
        <h3>{title}</h3>

        {!!children && <div className="page-header__subtitle">{children}</div>}
      </div>

      <div className="page-header__actions">{buttons}</div>
    </div>
  )
}

export default Header
